/* eslint-disable no-console */
import chalk from 'chalk';

export const logger = {
  error: (...args: unknown[]) => {
    console.log(chalk.red(...args));
  },
  warn: (...args: unknown[]) => {
    console.log(chalk.yellow(...args));
  },
  info: (...args: unknown[]) => {
    console.log(chalk.white(...args));
  },
  success: (...args: unknown[]) => {
    console.log(chalk.green(...args));
  },
  debug: (...args: unknown[]) => {
    console.log('TESTING :: ', args);
  },
  break: () => {
    console.log('');
  },
  highlight: (args: string) => chalk.cyan(args),
};

export default {
  logger,
};
